import { createDOMElement } from'./dom/create.mjs';
import { ujsxToHTML } from'./html/render.mjs';
import { ujsxToDOM } from'./dom/convert.mjs';
import { extractDOMContext } from'./dom/context.mjs';
import { createUJSXObject } from'./common/object.mjs';
export function ujsxFor(ctx) {
    const ectx = extractDOMContext(ctx);
    const createElement = ectx.window
        ? (tag, attributes, ...children) => createDOMElement(ectx, tag, attributes, ...children)
        : (tag, attributes, ...children) => createUJSXObject(tag, attributes, ...children);
    function ujsxToDOMBound(ujsx) {
        return ujsxToDOM(ectx, ujsx);
    }
    function ujsx(tag, attributes, ...children) {
        if (typeof tag == 'function')
            return tag(Object.assign({}, attributes, { children }));
        return createElement(tag, attributes, ...children);
    }
    return {
        ujsx,
        ujsxToHTML: (ujsx) => ujsxToHTML(ectx, ujsx),
        ujsxToDOM: ujsxToDOMBound
    };
}
//# sourceMappingURL=bind.mjs.map